"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrows_left_right = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var arrows_left_right = function arrows_left_right(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'arrows-left-right-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M7.53033 16.5304C7.82322 16.2375 7.82322 15.7626 7.53033 15.4697L5.06066 13L7.53033 10.5304C7.82322 10.2375 7.82322 9.76259 7.53033 9.4697C7.23744 9.1768 6.76256 9.1768 6.46967 9.4697L3.46967 12.4697C3.17678 12.7626 3.17678 13.2375 3.46967 13.5304L6.46967 16.5304C6.76256 16.8233 7.23744 16.8233 7.53033 16.5304Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M12.4697 3.46967C12.1768 3.76256 12.1768 4.23744 12.4697 4.53033L14.9393 7L12.4697 9.46967C12.1768 9.76256 12.1768 10.2374 12.4697 10.5303C12.7626 10.8232 13.2374 10.8232 13.5303 10.5303L16.5303 7.53033C16.8232 7.23744 16.8232 6.76256 16.5303 6.46967L13.5303 3.46967C13.2374 3.17678 12.7626 3.17678 12.4697 3.46967Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M4.25 7.00003C4.25 7.41424 4.58579 7.75003 5 7.75003H16C16.4142 7.75003 16.75 7.41424 16.75 7.00003C16.75 6.58581 16.4142 6.25003 16 6.25003H5C4.58579 6.25003 4.25 6.58581 4.25 7.00003Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M15.75 13C15.75 12.5858 15.4142 12.25 15 12.25H5C4.58579 12.25 4.25 12.5858 4.25 13C4.25 13.4142 4.58579 13.75 5 13.75H15C15.4142 13.75 15.75 13.4142 15.75 13Z',
    fill: '#4B5563'
  }));
};

exports.arrows_left_right = arrows_left_right;